import { createUseStyles } from "react-jss"

export default createUseStyles({
  content: {
    marginTop: 16,
    width: '100%'
  },
})
